var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1022.72px",
    height: "452.48px",
    viewBox: "0 0 1022.72 452.48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-799.290000, -2624.180000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(-0.060000, -1.890000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    fill: "#BEB0FF",
    fillRule: "nonzero",
    x: 1595.99,
    y: 3049.71,
    width: 113.04,
    height: 28.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    x: 888.95,
    y: 2635.75,
    width: 763.56,
    height: 428.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    fill: "#BEB0FF",
    fillRule: "nonzero",
    x: 799.35,
    y: 2626.07,
    width: 179.19,
    height: 45.72
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_54",
    fillOpacity: 0.5,
    fill: "#BEB0FF",
    points: "1709.03 2819.46 1822.07 2819.46 1822.07 2848.3 1709.03 2848.3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.fbdf964934d7710e073db1c54d6c8f62.svg";
export { ForwardRef as ReactComponent };